import checkmarkIcon from 'assets/icons/check.svg';
import SvgIcon from 'lib/SvgIcon/SvgIcon';
import { Color } from 'lib/SvgIcon/SvgIcon.types';
import warningIcon from 'assets/icons/warning.svg';
import closeIcon from 'assets/icons/close.svg';
import alertIcon from 'assets/icons/info.svg';

import AssetItem from './AssetItem';

export const RecordStatusIcon = {
  FAILED: alertIcon,
  SUCCESS: checkmarkIcon,
  ERROR: closeIcon,
  WARNING: warningIcon,
};

export type AssetDetailsProps = {
  newRecords?: number;
  errorRecords?: number;
  skippedRecords?: number;
  totalRecords?: number;
  updatedRecords?: number;
  isSuccess?: boolean;
};

const AssetDetails: React.FC<AssetDetailsProps> = ({
  newRecords = 0,
  errorRecords = 0,
  skippedRecords = 0,
  totalRecords = 0,
  updatedRecords = 0,
  isSuccess = false,
}) => {
  const errorRecordsIcon =
    errorRecords > 0 || !isSuccess ? (
      <SvgIcon src={RecordStatusIcon.FAILED} color={!isSuccess ? Color.DISABLED : Color.DANGER} />
    ) : (
      <SvgIcon src={RecordStatusIcon.SUCCESS} color={Color.SUCCESS} />
    );

  const skippedRecordsIcon =
    skippedRecords > 0 || !isSuccess ? (
      <SvgIcon src={RecordStatusIcon.WARNING} color={!isSuccess ? Color.DISABLED : Color.WARNING} />
    ) : (
      <SvgIcon src={RecordStatusIcon.SUCCESS} color={Color.SUCCESS} />
    );

  const recordsIcon = isSuccess ? (
    <SvgIcon src={RecordStatusIcon.SUCCESS} color={Color.SUCCESS} />
  ) : (
    <SvgIcon src={RecordStatusIcon.ERROR} color={!isSuccess ? Color.DISABLED : Color.DANGER} />
  );

  return (
    <>
      <AssetItem text="records processed" icon={recordsIcon} amountOfRecords={totalRecords} />
      <AssetItem text="new records created" icon={recordsIcon} amountOfRecords={newRecords} />
      <AssetItem text="records updated" icon={recordsIcon} amountOfRecords={updatedRecords} />
      <AssetItem text="errors found" icon={errorRecordsIcon} amountOfRecords={errorRecords} />
      <AssetItem text="skipped records" icon={skippedRecordsIcon} amountOfRecords={skippedRecords} />
    </>
  );
};

export default AssetDetails;
